// Station mapping utility functions

export const getStationName = (stationId) => {
  // Wiesn-Garten (Bierausschank) hat kein numerisches Kürzel
  if (String(stationId).toUpperCase() === 'WG') return 'Wiesn-Garten';
  const normalizedId = parseInt(stationId) || parseInt(parseFloat(stationId));
  const stations = {
    1: 'G1',
    5: 'G5',
    8: 'G8',
    10: 'G10'
  };
  return stations[normalizedId] || `Station ${stationId}`;
};

export const getStationId = (stationName) => {
  if (String(stationName).toUpperCase() === 'WG' || stationName === 'Wiesn-Garten') return 'WG';
  const stations = {
    'G1': 1,
    'G5': 5,
    'G8': 8,
    'G10': 10
  };
  return stations[stationName] || parseInt(stationName) || stationName;
};
